module.exports = __webpack_public_path__ + "static/media/checked.847aab66.svg";